import React from 'react'
import ValueObjectTypeForm from './ValueObjectTypeForm/ValueObjectTypeForm'
import ValueBasicInformationForm from './ValueBasicInformationForm/ValueBasicInformationForm'
// import ValueEnergyCertificateForm from './ValueEnergyCertificateForm/ValueEnergyCertificateForm'
import ValueOwnershipForm from './ValueOwnershipForm/ValueOwnershipForm'
import ValueRentalAndUsageForm from './ValueRentalAndUsageForm/ValueRentalAndUsageForm'

const ValueAddObjectDataForm = (props: any) => {
  const { currentSubTab } = props
  return (
    <>
      {currentSubTab === 0 && <ValueObjectTypeForm {...props} />}
      {currentSubTab === 1 && <ValueBasicInformationForm {...props} />}
      {currentSubTab === 2 && <ValueOwnershipForm {...props} />}
      {currentSubTab === 3 && <ValueRentalAndUsageForm {...props} />}
      {/* {currentSubTab === 4 && <ValueEnergyCertificateForm {...props} />} */}
    </>
  )
}

export default ValueAddObjectDataForm
